import { render, staticRenderFns } from "./downloadApp.vue?vue&type=template&id=4a0db1d5&scoped=true"
import script from "./downloadApp.vue?vue&type=script&lang=js"
export * from "./downloadApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0db1d5",
  null
  
)

export default component.exports